import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import orElse from 'volta/helpers/or-else';
import and from 'ember-truth-helpers/helpers/and';
import BvInline from 'volta/components/bv-inline';
import BvIcon from 'volta/components/bv-icon';
import BvText from 'volta/components/bv-text';
import type { IBvIconArgs } from '../bv-icon';
import type { BvTextSignature } from '../bv-text';
import type { TOC } from '@ember/component/template-only';
interface CodeDescSignature {
    Args: {
        code?: string;
        desc?: string;
        fontVariant?: BvTextSignature['Args']['variant'];
        icon?: IBvIconArgs['glyph'];
        iconColor?: IBvIconArgs['color'];
        iconSize?: IBvIconArgs['size'];
    };
    Element: HTMLElement;
}
const CodeDescComponent: TOC<CodeDescSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvInline
    class='code-desc u-flex-fill'
    @blockAlign='center'
    @gap='2'
    @wrap={{false}}
    ...attributes
  >
    {{#if @icon}}
      <BvIcon
        @glyph={{@icon}}
        @color={{@iconColor}}
        @size={{orElse @iconSize 'sm'}}
        class='code-desc__icon'
      />
    {{/if}}
    <BvInline @gap='1' @blockAlign='center' @wrap={{false}} class='u-overflow-hidden'>
      {{#if @code}}
        <BvText
          class='code'
          @text={{@code}}
          @fontWeight='semibold'
          @variant={{@fontVariant}}
          data-test-code
        />
      {{/if}}
      {{#if (and @code @desc)}}
        <BvText
          @text='•'
          @fontWeight='regular'
          @variant={{@fontVariant}}
          class='u-opacity-disabled'
        />
      {{/if}}
      {{#if @desc}}
        <BvText
          @text={{@desc}}
          @fontWeight={{if @code 'regular' 'semibold'}}
          @variant={{@fontVariant}}
          class='u-ellipsis'
          data-test-desc
        />
      {{/if}}
    </BvInline>
  </BvInline>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default CodeDescComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        CodeDesc: typeof CodeDescComponent;
        'code-desc': typeof CodeDescComponent;
    }
}
